import { Stack, Typography } from "@mui/material";
import AcxToggleButton from "components/UI/AcxToggleButton";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import React from "react";

export type ResultSource = "all" | "human" | "synthetic";

export function filterBySource(
    results: TestLLMClassifierAgreementResult[],
    source: ResultSource,
) {
    if (source === "all") return results;
    const isSynthetic = source === "synthetic";
    return results.filter(
        (result) => !!result.conversation.isSynthetic === isSynthetic,
    );
}

/** True when the results mix human-labeled and synthetic conversations. */
export function hasBothSources(results: TestLLMClassifierAgreementResult[]) {
    return (
        results.some((result) => result.conversation.isSynthetic) &&
        results.some((result) => !result.conversation.isSynthetic)
    );
}

interface ResultSourceFilterProps {
    id: string;
    results: TestLLMClassifierAgreementResult[];
    value: ResultSource;
    onChange: (source: ResultSource) => void;
}

export function ResultSourceFilter({
    id,
    results,
    value,
    onChange,
}: ResultSourceFilterProps) {
    const humanCount = filterBySource(results, "human").length;
    const syntheticCount = filterBySource(results, "synthetic").length;

    return (
        <Stack direction="row" alignItems="center" columnGap={1}>
            <Typography fontWeight={600}>Source</Typography>
            <AcxToggleButton
                id={id}
                exclusive
                defaultValue={value}
                onChange={(source) => {
                    if (source) onChange(source);
                }}
                items={[
                    { value: "all", element: `All (${results.length})` },
                    {
                        value: "human",
                        element: `Human labels (${humanCount})`,
                    },
                    {
                        value: "synthetic",
                        element: `Synthetic (${syntheticCount})`,
                    },
                ]}
            />
        </Stack>
    );
}
